/** Match confidence thresholds (0–1 scale from API). */
export const SCORE_TIER_THRESHOLDS = {
  HIGH: 0.9,
  MEDIUM: 0.7,
};

export const SCORE_TIER = {
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low',
  NONE: 'none',
};

export const SCORE_TIER_LABELS = {
  [SCORE_TIER.HIGH]: 'High confidence',
  [SCORE_TIER.MEDIUM]: 'Medium confidence',
  [SCORE_TIER.LOW]: 'Low confidence',
};
